export default "__VITE_ASSET__4hdSerLT__"